module.exports = __webpack_public_path__ + "static/media/webdesign-services-img53.abfe6c8d.jpg";